import Lottie from "lottie-react";
import SafeandSecure from "../../../assets/animations/SafeandSecure.json";

const TwoFaEnabled = () => {
  return (
    <div className="text-center">
      <Lottie
        animationData={SafeandSecure}
        loop={false}
        autoplay
        style={{ width: 300, margin: "0 auto" }}
      />
        <div class="twofa-badge" style={{color:"green"}}>
            <span class="dot"></span>
                Double authentification activé
            <span class="check">✔</span>
        </div>

    </div>
  );
};

export default TwoFaEnabled;
